import React from 'react';
import styled from 'styled-components';
// ── Size map ──────────────────────────────────────────────────────────────────
const SIZE_MAP = {
    large: { height: 50, padding: '0 48px', fontSize: 16 },
    medium: { height: 40, padding: '0 32px', fontSize: 14 },
    small: { height: 32, padding: '0 16px', fontSize: 14 },
};
// ── Styled ────────────────────────────────────────────────────────────────────
const ButtonEl = styled.button `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: ${p => p.height}px;
  padding: ${p => p.padding};
  font-size: ${p => p.fontSize}px;
  font-family: inherit;
  font-weight: 600;
  border: none;
  border-radius: ${p => p.radius};
  background-color: ${p => p.bgColor};
  color: ${p => p.textColor};
  cursor: ${p => (p.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${p => (p.disabled ? 0.5 : 1)};
  width: ${p => (p.fullWidth ? '100%' : 'auto')};
  text-decoration: none;
  transition: background-color 0.15s ease;

  &:hover:not(:disabled) {
    background-color: ${p => p.hoverColor};
  }
`;
// ── Spinner ───────────────────────────────────────────────────────────────────
const Spinner = styled.span `
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
// ── Component ─────────────────────────────────────────────────────────────────
const Pressable = ({ title = '', customColor = '#000000', customHoverColor, customTextColor = '#ffffff', size = 'large', fullWidth = false, isDisabled = false, loading = false, onPress, icon, borderRadius = 100, wrapperStyle, }) => {
    const { height, padding, fontSize } = SIZE_MAP[size] || SIZE_MAP.large;
    const radius = typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius;
    const hoverColor = customHoverColor || customColor;
    const disabled = isDisabled || loading;
    const content = (React.createElement(React.Fragment, null, loading ? (React.createElement(Spinner, null)) : (React.createElement(React.Fragment, null,
        icon && icon(),
        title && React.createElement("span", null, title)))));
    const sharedProps = {
        bgColor: customColor,
        hoverColor,
        textColor: customTextColor,
        height,
        padding,
        fontSize,
        radius,
        fullWidth,
        disabled,
        style: wrapperStyle,
    };
    return (React.createElement(ButtonEl, { ...sharedProps, onClick: !disabled ? onPress : undefined, type: "button" }, content));
};
export default Pressable;
